import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Seite nicht gefunden',
    body: 'Diese Adresse existiert nicht.',
    backLink: 'Zurück zur Übersicht',
  },
  configWarning: {
    body: '<0>Unvollständige Konfiguration.</0> {{missing}} fehlt. Lege dies in <1>.env.local</1> für die lokale Entwicklung fest (siehe <2>.env.example</2>), oder in der Container-Umgebung für ein Deployment.',
  },
  skipToContent: 'Zum Inhalt springen',
  brandName: 'NOLATR',
  mainNav: 'Hauptmenü',
  sectionNav: 'Bereich',
  accountNav: 'Konto',
  openMainMenu: 'Menü öffnen',
  closeMainMenu: 'Menü schließen',
  activeCompany: 'Aktives Unternehmen',
  profileStub: {
    title: 'Profil',
    lead: 'Deine Profilseite kommt bald — vorerst ist dies ein Platzhalter, damit die Shell einen Ort hat, an den sie dich schicken kann.',
  },
  manageStub: {
    title: 'Verwaltung',
    lead: 'Wähle einen Bereich im Menü.',
  },
};
